import { createContext, useEffect, useReducer } from "react";

const INITIAL_STATE = {
  buyer: JSON.parse(localStorage.getItem("buyer")) || null,
  loading: false,
  error: null,
};

export const AuthContext = createContext(INITIAL_STATE);

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        buyer: null,
        loading: true,
        error: null,
      };
    case "LOGIN_SUCCESS":
      return {
        buyer: action.payload,
        loading: false,
        error: null,
      };
    case "LOGIN_FAILURE":
      return {
        buyer: null,
        loading: false,
        error: action.payload,
      };
    case "LOGOUT":
      return {
        buyer: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("buyer", JSON.stringify(state.buyer));
  }, [state.buyer]);

  return (
    <AuthContext.Provider
      value={{
        buyer: state.buyer,
        loading: state.loading,
        error: state.error,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
